import axios from 'axios';
import _cloneDeep from 'lodash/cloneDeep';
import translationsAxios from "../../utils/axiosTranslations.config";

import convertCalculationResponse, {colors} from './utils/convertCalculationResponse';
import {CURRENCY, LOCALE} from "../../config";
import {debounce} from "lodash";
import {createSelector} from "reselect";

const actionTypes = {
  setActiveConstruction: 'CONSTRUCTION/SET_ACTIVE_CONSTRUCTION',
  setConstructions: 'CONSTRUCTION/SET_CONSTRUCTIONS',
  setParameters: 'CONSTRUCTION/SET_PARAMETERS',
  setSelected: 'CONSTRUCTION/SET_SELECTED',
  setTranslations: 'CONSTRUCTION/SET_TRANSLATIONS',
  setTranslationsError: 'CONSTRUCTION/SET_TRANSLATIONS_ERROR',
  updateGateAttributes: 'CONSTRUCTION/UPDATE_GATE_ATTRIBUTES',
  setGates: 'CONSTRUCTION/SET_GATES',
  setDoors: 'CONSTRUCTION/SET_DOORS',
  setWindows: 'CONSTRUCTION/SET_WINDOWS',
  setRoofingExtension: 'CONSTRUCTION/SET_ROOFING_EXTENSION',
};

const GATE_COLOR_KEY_BY_TYPE = {
  swing_gate: 'gates_swing_color',
  double_leaf_gate: 'gates_double_leaf_color',
  sectional_gate: 'gates_sectional_color',
  roller_gate: 'gates_roller_color',
};

const ORDERED_GATE_TYPES = [
  'swing_gate',
  'double_leaf_gate',
  'sectional_gate',
  'roller_gate',
];

const initialState = {
  price: null,
  transport: null,
  activeConstruction: null,
  constructionsLoaded: false,
  constructions: [],
  parameters_loaded: false,
  selectedWidth: null,
  selectedLength: null,
  selectedUplift: null,

  parameters: {
    first_height: [],
    single_horizontal_gate: [],
    length: [],
    second_height: [],
    uplift: [],
    single_vertical_gate: [],
    voivodeship: [],
    width: [],
    gate: [],
    gate_count: [],
    gate_rear_left: [],
    gate_rear_left_height: [],
    gate_rear_left_width: [],
    gate_ramp_rear_left_height: [],
    gate_ramp_rear_left_width: [],
    gate_left: [],
    gate_left_height: [],
    gate_left_width: [],
    gate_ramp_left_height: [],
    gate_ramp_left_width: [],
    gate_right: [],
    gate_right_height: [],
    gate_right_width: [],
    gate_ramp_right_height: [],
    gate_ramp_right_width: [],
  },

  selected: {
    first_height: null,
    single_horizontal_gate: null,
    length: null,
    second_height: null,
    uplift: null,
    single_vertical_gate: null,
    voivodeship: null,
    width: null,
    gate: null,
    gate_count: null,
    gate_rear_left: null,
    gate_rear_left_height: null,
    gate_rear_left_width: null,
    gate_ramp_rear_left_height: null,
    gate_ramp_rear_left_width: null,
    gate_left: null,
    gate_left_height: null,
    gate_left_width: null,
    gate_ramp_left_height: null,
    gate_ramp_left_width: null,
    gate_right: null,
    gate_right_height: null,
    gate_right_width: null,
    gate_ramp_right_height: null,
    gate_ramp_right_width: null,

    // 🔽 nowe okna (count/size)
    window_back_count: null,
    window_back_size: null,
    window_left_count: null,
    window_left_size: null,
    window_right_count: null,
    window_right_size: null,

    // 🔽 nowe pola – uchylne TAK/NIE
    window_back_tilt: 2,
    window_left_tilt: 2,
    window_right_tilt: 2,

    window_back_color: 1,
    window_left_color: 1,
    window_right_color: 1,

    // nowe przetloczenia

    gates_pressing_swing_gate: 1,
    gates_pressing_double_leaf_gate: 1,
    gates_pressing_sectional_gate: 1,
    gates_pressing_roller_gate: 1,

    gates_swing_color: null,
    gates_double_leaf_color: null,
    gates_sectional_color: null,
    gates_roller_color: null,
  },

  available: {
    first_height: [],
    single_horizontal_gate: [],
    length: [],
    second_height: [],
    uplift: [],
    single_vertical_gate: [],
    voivodeship: [],
    width: [],
    gate: [],
    gate_count: [],
    gate_rear_left: [],
    gate_rear_left_height: [],
    gate_rear_left_width: [],
    gate_ramp_rear_left_height: [],
    gate_ramp_rear_left_width: [],
    gate_left: [],
    gate_left_height: [],
    gate_left_width: [],
    gate_ramp_left_height: [],
    gate_ramp_left_width: [],
    gate_right: [],
    gate_right_height: [],
    gate_right_width: [],
    gate_ramp_right_height: [],
    gate_ramp_right_width: [],

    door_back_count: [],
    door_back_size: [],
    door_front_count: [],
    door_front_size: [],
    door_left_count: [],
    door_left_size: [],
    door_right_count: [],
    door_right_size: [],

    hole_back_count: [],
    hole_back_size: [],
    hole_front_count: [],
    hole_front_size: [],
    hole_left_count: [],
    hole_left_size: [],
    hole_right_count: [],
    hole_right_size: [],

    window_back_count: [],
    window_back_size: [],
    window_front_count: [],
    window_front_size: [],
    window_left_count: [],
    window_left_size: [],
    window_right_count: [],
    window_right_size: [],

    plexiglass_skylight_back_count: [],
    plexiglass_skylight_back_size: [],
    plexiglass_skylight_front_count: [],
    plexiglass_skylight_front_size: [],
    plexiglass_skylight_left_count: [],
    plexiglass_skylight_left_size: [],
    plexiglass_skylight_right_count: [],
    plexiglass_skylight_right_size: [],

    shutter_back_count: [],
    shutter_back_size: [],
    shutter_back_material: [],
    shutter_front_size: [],
    shutter_front_count: [],
    shutter_front_material: [],
    shutter_left_count: [],
    shutter_left_size: [],
    shutter_left_material: [],
    shutter_right_count: [],
    shutter_right_size: [],
    shutter_right_material: [],

    roofing: [],
    roofing_placement: [],
    inside: [],
    structure: [],
    tooling: [],
    pressing: [],
    gates_pressing: [],
    anchoring: [],
    bolt: [],
    closing: [],
    additional_closing_remote: [],
    moisture_protection: [],
    padlock_holder: [],
    colors: [],
    lattice: [],
    sheet_thickness: [],

    matt: [],
    smooth: [],
    wooden: [],
  },

  info: {
    first_height: null,
    single_horizontal_gate: null,
    length: null,
    second_height: null,
    uplift: null,
    single_vertical_gate: null,
    voivodeship: null,
    width: null,
    gate: null,
    gate_count: null,
    gate_rear_left: null,
    gate_rear_left_height: null,
    gate_rear_left_width: null,
    gate_ramp_rear_left_height: null,
    gate_ramp_rear_left_width: null,
    gate_left: null,
    gate_left_height: null,
    gate_left_width: null,
    gate_ramp_left_height: null,
    gate_ramp_left_width: null,
    gate_right: null,
    gate_right_height: null,
    gate_right_width: null,
    gate_ramp_right_height: null,
    gate_ramp_right_width: null,
  },

  subtypes: {
    door_back_count: null,
    door_back_size: null,
    door_front_count: null,
    door_front_size: null,
    door_left_count: null,
    door_left_size: null,
    door_right_count: null,
    door_right_size: null,
    hole_back_count: null,
    hole_back_size: null,
    hole_front_count: null,
    hole_front_size: null,
    hole_left_count: null,
    hole_left_size: null,
    hole_right_count: null,
    hole_right_size: null,
    single_horizontal_gate: null,
    single_vertical_gate: null,
    window_back_count: null,
    window_back_size: null,
    window_front_count: null,
    window_front_size: null,
    window_left_count: null,
    window_left_size: null,
    window_right_count: null,
    window_right_size: null,
    shutter_back_count: null,
    shutter_back_size: null,
    shutter_back_material: null,
    shutter_front_size: null,
    shutter_front_count: null,
    shutter_front_material: null,
    shutter_left_count: null,
    shutter_left_size: null,
    shutter_left_material: null,
    shutter_right_count: null,
    shutter_right_size: null,
    shutter_right_material: null,
    plexiglass_skylight_back_count: null,
    plexiglass_skylight_back_size: null,
    plexiglass_skylight_front_count: null,
    plexiglass_skylight_front_size: null,
    plexiglass_skylight_left_count: null,
    plexiglass_skylight_left_size: null,
    plexiglass_skylight_right_count: null,
    plexiglass_skylight_right_size: null,
    roofing: null,
    roofing_placement: null,
    sheet_thickness: null,
  },

  gates: {
    count: 1,
    available_count: [1],
    gates: [
      {
        type: 'swing_gate',
        height: 200,
        width: 300,
        position: 0,
      }
    ]
  },

  doors: {
    left_wall: {
      count: 0,
      doors: []
    },
    right_wall: {
      count: 0,
      doors: []
    },
    back_wall: {
      count: 0,
      doors: []
    },
    front_wall: {
      count: 0,
      doors: []
    }
  },

  windows: {
    left_wall: {
      count: 0,
      openings: [],
      openings_flaps: [],
      pcv: [],
      plexi: [],
    },
    right_wall: {
      count: 0,
      openings: [],
      openings_flaps: [],
      pcv: [],
      plexi: [],
    },
    back_wall: {
      count: 0,
      openings: [],
      openings_flaps: [],
      pcv: [],
      plexi: [],
    },
    front_wall: {
      count: 0,
      openings: [],
      openings_flaps: [],
      pcv: [],
      plexi: [],
    }
  },

  // 🔽 NOWE: zadaszenie (opcje w newData)
  roofingExtension: {
    size: null,            // wielkość zadaszenia
    placement: null,       // 'left' | 'right' | null
    wall_left_type: null,
    wall_front_type: null,
    wall_right_type: null,
  },

  translations: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.setActiveConstruction: {
      console.log("⚠️ setActiveConstruction, activeConstruction changed:", action.payload);
      return {
        ...state,
        activeConstruction: action.payload,
        // constructionsLoaded: false
      };
    }

    case actionTypes.setConstructions: {
      return {
        ...state,
        constructions: action.payload
      };
    }

    case actionTypes.setParameters: {
      const {
        available,
        parameters,
        info,
        selected,
        subtypes,
        newData,
      } = action.payload.parameters;

      const nextAvailable = _cloneDeep(available);
      const nextGates = newData?.gates ? _cloneDeep(newData.gates) : state.gates;

      const mergedSelected = {
        ...state.selected,
        ..._cloneDeep(selected),
      };

      // ✅ default: pierwszy z subtype smooth
      const defaultSmoothId = nextAvailable?.smooth?.[0]?.id ?? null;

      if (defaultSmoothId) {
        const presentTypes = new Set(
          (nextGates?.gates || []).map((g) => g?.type).filter(Boolean)
        );

        const anyTypedGatePresent = ORDERED_GATE_TYPES.some((t) => presentTypes.has(t));

        if (anyTypedGatePresent) {
          ORDERED_GATE_TYPES.forEach((t) => {
            if (!presentTypes.has(t)) return;

            const key = GATE_COLOR_KEY_BY_TYPE[t];
            if (!key) return;

            if (mergedSelected[key] === null || mergedSelected[key] === undefined) {
              mergedSelected[key] = defaultSmoothId;
            }
          });
        } else {
          // fallback na stare globalne (jeśli w ogóle jeszcze istnieje w Twoim projekcie)
          if (mergedSelected.gates_color === null || mergedSelected.gates_color === undefined) {
            mergedSelected.gates_color = defaultSmoothId;
          }
        }
      }

      return {
        ...state,
        price: action.payload.price,
        transport: action.payload.transport,
        available: nextAvailable,
        parameters: _cloneDeep(parameters),
        info: _cloneDeep(info),

        // MERGE zamiast nadpisania (z defaultami)
        selected: mergedSelected,

        subtypes: _cloneDeep(subtypes),
        parameters_loaded: true,
        constructionsLoaded: true,

        gates: nextGates,
        doors: newData?.doors ? _cloneDeep(newData.doors) : state.doors,
        windows: newData?.windows ? _cloneDeep(newData.windows) : state.windows,
        roofingExtension: newData?.roofingExtension
          ? _cloneDeep(newData.roofingExtension)
          : state.roofingExtension,
      };
    }


    case actionTypes.setSelected: {
      return {
        ...state,
        selected: {
          ...state.selected,
          [action.payload.name]: action.payload.value
        }
      };
    }

    case actionTypes.setTranslations:
      return {
        ...state,
        translations: action.payload,
      };

    case actionTypes.setTranslationsError:
      return {
        ...state,
        translations: {},
      };

    case actionTypes.updateGateAttributes: {
      const { gateName, attributes } = action.payload;

      return {
        ...state,
        selected: {
          ...state.selected,
          [gateName]: attributes,
        },
      };
    }

    case actionTypes.setGates: {
      console.log('setuje gejty');
      return {
        ...state,
        gates: {
          ...state.gates,
          count: action.payload.count ?? state.gates.count,
          available_count: action.payload.available_count
            ? [...action.payload.available_count]
            : [...state.gates.available_count],
          gates: action.payload.gates
            ? action.payload.gates.map(g => ({ ...g }))
            : state.gates.gates.map(g => ({ ...g })),
        },
      };
    }

    case actionTypes.setDoors: {
      const { wall, doors = [] } = action.payload;
      console.log(wall, doors);
      console.log('setuje drzwi');
      return {
        ...state,
        doors: {
          ...state.doors,
          [wall]: {
            doors,
            count: Array.isArray(doors) ? doors.length : 0,
          },
        },
      };
    }

    case actionTypes.setWindows: {
      const { wall, type, windows = [] } = action.payload;

      // Aktualizujemy tylko wybrany typ
      const updatedWallWindows = {
        ...state.windows[wall],
        [type]: windows,
      };

      const count = [
        updatedWallWindows.openings,
        updatedWallWindows.openings_flaps,
        updatedWallWindows.pcv,
        updatedWallWindows.plexi,
      ].reduce((acc, arr) => acc + (Array.isArray(arr) ? arr.length : 0), 0);

      return {
        ...state,
        windows: {
          ...state.windows,
          [wall]: {
            ...updatedWallWindows,
            count,
          },
        },
      };
    }

    case actionTypes.setRoofingExtension: {
      return {
        ...state,
        roofingExtension: {
          ...state.roofingExtension,
          ...action.payload,
        },
      };
    }

    default:
      return {
        ...state
      };
  }
}

const setConstructions = (constructions) => ({
  type: actionTypes.setConstructions,
  payload: constructions
});

const setActiveConstruction = (constructionId) => ({
  type: actionTypes.setActiveConstruction,
  payload: constructionId
});

const setParameters = (parameters, price, transport) => ({
  type: actionTypes.setParameters,
  payload: {
    parameters,
    price,
    transport
  }
});

const parseToRequest = (selected) => {
  const requestData = {};

  Object.keys(selected).forEach((el) => {
    const value = selected[el];

    // nic nie wybrane – nie wysyłamy
    if (value === null || value === undefined) {
      return;
    }

    requestData[`${el}_selected`] = {
      data: {
        id: value,
        type: el,
      },
    };
  });

  return requestData;
};

export const getRequestData = (withParameters = true) => (_, getStore) => {
  const appStore = getStore().Construction;

  let requestData = {
    type: 'calculation',
    currency: CURRENCY,
    relationships: {
      construction: {
        data: {
          type: 'construction',
          id: appStore.activeConstruction
        }
      }
    },
    locale: LOCALE,
  };

  if (withParameters) {
    const selectedData = parseToRequest(appStore.selected);

    // 🔹 BIERZEMY ID bezpośrednio z selected
    const roofingSelectedId = appStore.selected.roofing ?? null;
    const roofingPlacementSelectedId = appStore.selected.roofing_placement ?? null;

    // 🔹 Ściany bierzemy ze state.roofingExtension
    const roofingExtensionState = appStore.roofingExtension || {};

    const roofingExtension = {
      size: roofingSelectedId,                 // ID zadaszenia
      placement: roofingPlacementSelectedId,   // ID placementu
      wall_left_type: roofingExtensionState.wall_left_type ?? null,
      wall_front_type: roofingExtensionState.wall_front_type ?? null,
      wall_right_type: roofingExtensionState.wall_right_type ?? null,
    };

    requestData = {
      ...requestData,
      relationships: {
        ...requestData.relationships,
        ...selectedData
      },
      newData: {
        gates: appStore.gates,
        doors: appStore.doors,
        windows: appStore.windows,
        roofingExtension,
      }
    };
  }

  return requestData;
};

const sendCalculation = (withParameters = true) => (dispatch) => {
  const requestData = dispatch(getRequestData(withParameters));

  axios.post('calculation', requestData).then(({ data }) => {
    console.log("Raw backend response:", data);

    const convertedData = convertCalculationResponse(data);
    console.log("Converted response:", convertedData);

    dispatch(setParameters(convertedData, data.attributes?.price, data.attributes?.transport));
  }).catch(err => {
    console.error("Calculation request failed:", err);
  });
};

const debouncedSendCalculation = debounce(
  (dispatch) => dispatch(sendCalculation()),
  250
);

const getInitialParameters = () => (dispatch) => {
  dispatch(sendCalculation(false));
};

const handleSetSelected = (name, value) => ({
  type: actionTypes.setSelected,
  payload: {
    name,
    value
  }
});

const setTranslations = (translations) => ({
  type: actionTypes.setTranslations,
  payload: translations,
});

const setTranslationsError = (error) => ({
  type: actionTypes.setTranslationsError,
  payload: error,
});

export const updateGateAttributes = (gateName, attributes) => ({
  type: actionTypes.updateGateAttributes,
  payload: { gateName, attributes },
});

export const translations = () => (dispatch) => {
  translationsAxios.get('')
    .then((response) => {
      dispatch(setTranslations(response.data));
    })
    .catch((error) => {
      dispatch(setTranslationsError(error));
    });
};

export const resetSettings = () => (dispatch) => {
  dispatch(getInitialParameters());
};

export const setAllColors = (value, isWooden) => (dispatch, getStore) => {
  const store = getStore().Construction;

  // stare zachowanie (jak było)
  colors.forEach((color) => {
    if (store.selected[color]) {
      if (color.toLowerCase().indexOf('roof') === -1) {
        dispatch(handleSetSelected(color, value));
      } else if (!isWooden) {
        dispatch(handleSetSelected(color, value));
      }
    }
  });

  // ✅ nowe: ustaw też kolory bram per-typ dla obecnych typów bram
  const presentTypes = new Set(
    (store.gates?.gates || []).map((g) => g?.type).filter(Boolean)
  );

  ORDERED_GATE_TYPES.forEach((t) => {
    if (!presentTypes.has(t)) return;

    const key = GATE_COLOR_KEY_BY_TYPE[t];
    if (!key) return;

    dispatch(handleSetSelected(key, value));
  });

  dispatch(sendCalculation());
};


export const setSelected = (name, value) => (dispatch) => {
  dispatch(handleSetSelected(name, value));
  dispatch(sendCalculation());
};

export const handleConstructionChange = (constructionId) => (dispatch) => {
  dispatch(setActiveConstruction(constructionId));
  dispatch(getInitialParameters());
};

export const setGates = (gatesObject) => (dispatch) => {
  dispatch({ type: actionTypes.setGates, payload: gatesObject });
  debouncedSendCalculation(dispatch);
};

export const setDoors = (wall, doors) => (dispatch) => {
  dispatch({ type: actionTypes.setDoors, payload: { wall, doors } });
  debouncedSendCalculation(dispatch);
};

export const setWindows = (wall, type, windows) => (dispatch) => {
  dispatch({ type: actionTypes.setWindows, payload: { wall, type, windows } });
  debouncedSendCalculation(dispatch);
};

export const setRoofingExtension = (roofingExtension) => (dispatch) => {
  dispatch({ type: actionTypes.setRoofingExtension, payload: roofingExtension });
  debouncedSendCalculation(dispatch);
};

export const selectDoors = (state) => state.Construction.doors;
export const selectGates = (state) => state.Construction.gates;
export const selectWindows = (state) => state.Construction.windows;
export const selectRoofingExtension = (state) => state.Construction.roofingExtension;

export const selectWidth = (state) => {
  const selectedWidthId = state.Construction.selected.width;
  const selectedWidthElement = state.Construction.available.width.find((el) => el.id === selectedWidthId);
  return selectedWidthElement?.attributes?.value_cm || 0;
};

export const selectLength = (state) => {
  const selectedLengthId = state.Construction.selected.length;
  const selectedLengthElement = state.Construction.available.length.find((el) => el.id === selectedLengthId);
  return selectedLengthElement?.attributes?.value_cm || 0;
};

export const selectFirstHeight = (state) => {
  const selectedHeightId = state.Construction.selected.first_height;
  const selectedHeightElement = state.Construction.available.first_height.find((el) => el.id === selectedHeightId);
  return selectedHeightElement?.attributes?.value_cm || 0;
};

export const selectSecondHeight = (state) => {
  const selectedHeightId = state.Construction.selected.second_height;
  const selectedHeightElement = state.Construction.available.second_height.find((el) => el.id === selectedHeightId);
  return selectedHeightElement?.attributes?.value_cm || 0;
};

const selectConstruction = (state) => state.Construction;
const selectSelected = createSelector(selectConstruction, (c) => c.selected);
export const selectColors = createSelector([selectSelected], (selected) => ({
  doors_back_color: selected.doors_back_color,
  doors_front_color: selected.doors_front_color,
  doors_left_color: selected.doors_left_color,
  doors_right_color: selected.doors_right_color,

  // stare globalne (jeśli jeszcze gdzieś używasz)
  gates_color: selected.gates_color,

  // ✅ nowe per typ bramy (Twoje nazwy)
  gates_swing_color: selected.gates_swing_color,
  gates_double_leaf_color: selected.gates_double_leaf_color,
  gates_sectional_color: selected.gates_sectional_color,
  gates_roller_color: selected.gates_roller_color,

  pressing: selected.pressing,
  gates_pressing: selected.gates_pressing,

  gates_pressing_swing_gate: selected.gates_pressing_swing_gate,
  gates_pressing_double_leaf_gate: selected.gates_pressing_double_leaf_gate,
  gates_pressing_sectional_gate: selected.gates_pressing_sectional_gate,
  gates_pressing_roller_gate: selected.gates_pressing_roller_gate,

  roof_color: selected.roof_color,
  roof_tooling_color: selected.roof_tooling_color,
  roofing_color: selected.roofing_color,
  tooling: selected.tooling,
  tooling_color: selected.tooling_color,
  gutters_color: selected.gutters_color,
  walls_color: selected.walls_color,
}));


export const loadConfiguration = () => (dispatch) => {
  axios.get('constructions?locale=' + LOCALE).then(({ data }) => {

    const response = Array.isArray(data) ? data : data.constructions; // Adjust as needed
    if (!Array.isArray(response)) {
      throw new Error("Expected an array but received:", response);
    }

    const defaultConstruction = response.find((el) => el.attributes.is_default);
    if (!defaultConstruction) {
      throw new Error("No default construction found");
    }

    dispatch(handleConstructionChange(defaultConstruction.id));
    dispatch(setConstructions(response));
  }).catch(error => {
    console.error("Error fetching constructions:", error);
  });
};
